import { LocalStorageSvc } from "@commoncore/services/localStorage.service";

export class Controller{
    
    public universalService:any;
    public localStorageSvc: LocalStorageSvc;
    public listService:any;

    constructor(globalService){

    }
    public allFilesImplementation:any;
    public fileOperationsImplementation:any;

    setEnvObjects(globalService){}
    getAllFiles(){}
    onScrollDown(docheignt,toppos,containerName){}
    openFolder(folder){}
    openPublicSort(sortType,reverseOrder){}

    checkDeviceType(){}
    checkPage(){}
    fetchingShareKeyFromUrl(){}
    setRequiredData(){}
    checkIfSessionIsTimedOutOnPageRefresh(){}

    addtoJioCloud(files){}
    getFolders(sortType){}

    getAudios(){}
    onMobileScrollDown(docheignt,toppos){}
   
   
    
}